import { connect } from 'react-redux';
import { pushNftEditPopup } from '../../Modals/redux/actionCreators';
import { getIsCurrentUserAuthorOf } from '../../redux/deviations/selectors';
const mapStateToProps = (state, ownProps)=>({
        isOwner: getIsCurrentUserAuthorOf(state, ownProps.deviation)
    });
const mapDispatchToProps = {
    showNftEditPopup: pushNftEditPopup
};
export default connect(mapStateToProps, mapDispatchToProps);
